export const ERROR_SENDING_EVENT = (service: string) => `Error sending event to ${service}`
export const ERROR_GETTING_INSTANCE = (service: string) => `Error getting instance of ${service}`
export const ERROR_INITIALIZING = (service: string) => `Error initiliazing ${service}`
